app = {
	window: $(window),
	document: $(document),
	body: $('body'),
	ww: window.innerWidth,
	hh: window.innerHeight,
	mcW: window.innerWidth,
	mcH: window.innerHeight - 40,
	sectionW: window.innerWidth,
	sectionH: window.innerHeight,
	url: $('body').attr('data-siteurl'),
	baseUrl: window.location.origin,
	pathname: window.location.pathname,
	currentURL: window.location.href,
	isHistoryAvailable : true
}

if(typeof history.pushState === 'undefined') {
	app.isHistoryAvailable = false;
}